import React from 'react';
import * as FiIcons from 'react-icons/fi';
import { FiAlertTriangle } from 'react-icons/fi';

const SafeIcon = ({ icon, name, className = '', ...props }) => {
  // Déterminer le composant d'icône à utiliser
  let IconComponent = null;

  try {
    if (icon && typeof icon === 'function') {
      // Priorité 1: Composant passé directement
      IconComponent = icon;
    } else if (name && typeof name === 'string') {
      // Priorité 2: Nom de l'icône
      const iconName = name.startsWith('Fi') ? name : `Fi${name}`;
      IconComponent = FiIcons[iconName];
    }
  } catch (error) {
    console.warn('Erreur lors de la sélection de l\'icône:', error);
    IconComponent = null;
  }

  // Validation finale et rendu
  if (IconComponent && typeof IconComponent === 'function') {
    return <IconComponent className={className} {...props} />;
  }

  // Fallback vers icône d'alerte
  return <FiAlertTriangle className={className} {...props} />;
};

export default SafeIcon;